import { Button } from 'antd';
import { Flex } from '@/ui';
import { COLORS } from '@/utils/static';
import { STATUS } from '@/utils/static/kyc';
import { DeleteOutlined, FilePdfFilled } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const isOpenButtonDisabled = ({
  isVerification,
  adminView,
  disabled,
  isOpenButtonEnabled = false,
  investorAccountStatus,
  record,
  referralView
}) => {
  if (isOpenButtonEnabled) {
    return false;
  }

  if (isVerification) {
    return adminView
      ? false
      : !(investorAccountStatus === 'ACTIVE' && (adminView || !record.isAnswered)) ||
          record.status === 'In process' ||
          record.status === 'Accepted' ||
          referralView;
  }

  if (adminView) {
    return false;
  }

  return disabled || !record.enabled || !record.viewPermission;
};

const handleOpenClick = ({
  isVerification,
  adminView,
  investorId,
  navigate,
  location,
  record,
  onClick
}) => {
  if (isVerification) {
    navigate(adminView ? `/investor/${investorId}/sumsub-verification` : '/sumsub-verification', {
      state: {
        prevPath: location.pathname
      }
    });
    return;
  }

  if (record.onClick) {
    record.onClick(record.id);
    return;
  }

  if (onClick) {
    onClick(record.id);
  }
};

export const ActionsColumn = ({
  record,
  adminView,
  isVerification,
  isDocumentTable,
  disabled,
  isOpenButtonEnabled,
  referralView,
  investorAccountStatus,
  investorId,
  navigate,
  location,
  onClick,
  onClickEdit,
  onClickDelete,
  onDelete,
  downloadPdf,
  isDocumentsFromQuestionnaires = false
}) => {
  const { t } = useTranslation();

  const openButtonDisabled = isOpenButtonDisabled({
    isVerification,
    adminView,
    disabled,
    isOpenButtonEnabled,
    investorAccountStatus,
    record,
    referralView
  });

  const handleOpen = () => {
    handleOpenClick({
      isVerification,
      adminView,
      investorId,
      navigate,
      location,
      record,
      onClick
    });
  };

  return (
    <Flex gap={8}>
      {adminView && record.pdfUrl && (
        <Button
          size='small'
          icon={<FilePdfFilled />}
          variant='primary'
          onClick={() => downloadPdf(record.pdfUrl, record.name)}
        />
      )}

      <Button
        size='small'
        variant='solid'
        disabled={openButtonDisabled}
        onClick={handleOpen}
        color='blue'
      >
        {isDocumentTable && isDocumentsFromQuestionnaires ? t('Download') : t('Open')}
      </Button>

      {onClickEdit && adminView && !isVerification && (
        <Button size='small' variant='solid' onClick={() => onClickEdit(record.id)} color='gold'>
          {t('Edit')}
        </Button>
      )}

      {onClickDelete &&
        record.status === STATUS.NEW &&
        adminView &&
        !isDocumentTable &&
        !isVerification && (
          <Button
            icon={<DeleteOutlined />}
            size='small'
            variant='primary'
            style={{ backgroundColor: COLORS.red, color: COLORS.white }}
            onClick={() => onClickDelete(record.id)}
          />
        )}

      {adminView && isDocumentTable && !isVerification && record.status === STATUS.NEW && (
        <Button
          icon={<DeleteOutlined />}
          size='small'
          variant='primary'
          style={{ backgroundColor: COLORS.red }}
          onClick={() => onDelete(record.id)}
        />
      )}
    </Flex>
  );
};
